import React, { useState, useContext, useEffect } from 'react'
import AdminContext from '../../../StateContext/Application';
import "../../page.css"
import { ApproveRequest, Cancel32, Close32, DeleteRed32, EditBlueBlue32, submit } from '../../../../../public/LoginImages/importimages';
const Requisitions = () => {
  const context = useContext(AdminContext);
  const { GetProjectsDetails, AddExpenses, ApprovedOrRejectExpense } = context;
  const [expenses, setExpenses] = useState([]);
  const [selectedExpense, setSelectedExpense] = useState(null);
  const [approvedAmount, setApprovedAmount] = useState('');
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectingExpense, setRejectingExpense] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 10;

const indexOfLastBill = currentPage * itemsPerPage;
const indexOfFirstBill = indexOfLastBill - itemsPerPage;
const currentExpenses = expenses.slice(indexOfFirstBill, indexOfLastBill);
const totalPages = Math.ceil(expenses.length / itemsPerPage);

  useEffect(() => {
    GetExpenses();
  }, [])
  const GetExpenses = async () => {
    try {
      let data = await AddExpenses([], "getRequests");
      setExpenses(data);
    } catch (error) {
      console.error("Error in GetProjects:", error);
    }
  };

  const handleApproveSubmit = async () => {

    try {
      if (!approvedAmount || isNaN(approvedAmount)) {
        alert('Please enter a valid approved amount');
        return;
      }
      console.log(approvedAmount);
      let selectedExpenseid = selectedExpense.Request_Id;
      let data = await ApprovedOrRejectExpense(selectedExpenseid, approvedAmount, "Approve");
      console.log(data);
      alert(data.message);
      // alert('Expense approved successfully');
      setSelectedExpense(null);
      setApprovedAmount('');
      GetExpenses();
    } catch (err) {
      console.error(err);
      alert('Error approving expense');
    }
  };
  const handleRejectSubmit = async () => {
    try {
      let rejectingExpenseid = rejectingExpense.Request_Id;
      let data = await ApprovedOrRejectExpense(rejectingExpenseid, 0, "Reject");
      console.log(data);
      alert(data.message);
      // alert('Expense rejected successfully');
      setShowRejectModal(false);
      setRejectingExpense(null);
      GetExpenses(); // Refresh table
    } catch (err) {
      console.error(err);
      alert('Error rejecting expense');
    }
  };

  return (
    <>
      <div style={{ display: 'grid', justifyContent: 'center', alignItems: 'center', backgroundColor: '#f4f7fe', overflowY: 'auto', maxHeight: '91vh', padding: '0px 0px 20px 0px' }}>

        <div style={{ display: 'grid', justifyContent: 'center', padding: "20px 0px 0px 0px" }}>
          <div style={{ display: 'grid', justifyContent: 'center', width: '75vw', borderRadius: '20px', backgroundColor: 'white', padding: '2rem', }}>
            <h5 className='my-4' style={{ background: 'linear-gradient(to bottom, #3b409e, #0067ab, #0f79ba, #0098d5)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', fontWeight: '700', }}>Requisitions Request</h5>
            <div style={{ display: 'flex', justifyContent: 'center', width: '70vw', backgroundColor: '#e8f7f3', border: '1px solid darkgray' }}>
              <table style={{ backgroundColor: '#e8f7f3', width: '100%' }}>
                <thead>
                  <tr style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', height: '2.5rem' }}>
                    <th>Sr.No.</th>
                    <th>Request Id</th>
                    <th>Project Name</th>
                    <th>User Name</th>
                    <th>Expense Type</th>
                    <th>Requested Amount</th>
                    <th>Approved Amount</th>
                    <th>Description</th>
                    <th>Actions</th>
                  </tr>
                  {currentExpenses.map((expense, index) => (
                    <tr key={expense.id}>
                      <td>{index + 1}</td>
                      <td>{expense.Request_Id}</td>
                      <td>{expense.Project_Name}</td>
                      <td>{expense.User_Name}</td>
                      <td>{expense.Expense_Type}</td>
                      <td>{expense.Amount}</td>
                      <td>{expense.Approved_Amount}</td>
                      <td>{expense.Description}</td>
                      <td>
                        <div style={{ display: 'flex', padding: '5px' }}>
                          <button className="btn btn-custom-edit"
                            style={{
                              display: 'flex',
                              width: '6.8rem',
                              border: '1px solid #502eff',
                              backgroundColor: 'white',
                              borderRadius: '5px',
                              padding: '5px',
                              fontSize: '14px',
                              color: '#502eff',
                              fontWeight: '700'
                            }} onClick={() => setSelectedExpense(expense)} disabled={expense.Amount == expense.Approved_Amount}> <img className="icon-edit" src={EditBlueBlue32} style={{ width: '1.3rem' }} />
                            {expense.Amount == expense.Approved_Amount ? "(Approved)" : "Approve"}
                          </button>
                          <button className="btn btn-custom-delete"
                            style={{
                              width: '6rem',
                              border: '1px solid #ee5d50',
                              backgroundColor: 'white',
                              borderRadius: '5px',
                              padding: '5px',
                              marginLeft: '10px',
                              color: '#ee5d50',
                              fontSize: '14px',
                              fontWeight: '700'
                            }}
                            onClick={() => {
                              setRejectingExpense(expense);
                              setShowRejectModal(true);
                            }} disabled={expense.Amount == expense.Approved_Amount || expense.Approved_By == "Accounts(Rejected)"}><img className="icon-delete"
                              src={DeleteRed32}
                              style={{ width: '1.3rem', paddingBottom: '0.2rem' }}
                            />
                            {expense.Approved_By == "Accounts(Rejected)" ? "Rejected" : "Reject"}
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </thead>
              </table>
              {selectedExpense && (
                <>
                  <div className="modal-backdrop" onClick={() => { setSelectedExpense(null); setApprovedAmount(''); }} />

                  <div className="modal-content-box" >
                    <div style={{ padding: '1rem 2rem 2rem 2rem',display:'grid',gap:'10px' }}>
                      <div className='my-3' style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}><img  style={{ width: '20px', paddingBottom: '5px' }} />
                          <h5 style={{ textAlign: 'center' }}>Approve Request</h5>
                        </div>
                        <div><img   onClick={() => { setSelectedExpense(null); setApprovedAmount(''); }}/></div>
                      </div>
                      <div style={{backgroundColor:'#f4f4f4'}}>
                        <div className='mx-3' style={{padding:'1rem'}}>
                          <div><strong>Request ID:</strong> {selectedExpense.Request_Id}</div>
                          <div><strong>Project:</strong> {selectedExpense.Project_Name}</div>
                          <div><strong>Requested Amount:</strong> ₹{selectedExpense.Amount}</div>
                          <div><strong>Approved Amount:</strong> ₹{selectedExpense.Approved_Amount }</div>
                        </div>
                      </div>

                      <div style={{ background: 'linear-gradient(to Right, #B2E0F2 , #B7D7EA , #B2D1E6 , #C4C5E2 )',borderRadius:'10px'}}>
                      <div className='mx-3' style={{padding:'1rem'}}>
                        <label className='my-3'style={{fontWeight:'600'}}>Approved Amount</label>
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Enter approved amount"
                          value={approvedAmount}
                          onChange={(e) => setApprovedAmount(e.target.value)}
                        />
                      </div>
                     </div>

                     <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1rem', paddingTop: '10px' }}>
                        <button
                          style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "8rem", height: "2.5rem", background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', border: 'none', fontSize: '17px', gap: '4px' }}
                          onClick={handleApproveSubmit}
                        ><img src={submit}style={{ width: '1.2rem', paddingBottom: '3px', fontSize: '15px' }}/>
                          Submit
                        </button>
                        <button
                          style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "7rem", height: "2.5rem", backgroundColor: '#E63E23', border: 'none', fontSize: '17px', gap: '4px' }}
                          onClick={() => { setSelectedExpense(null); setApprovedAmount(''); }}
                        ><img src={Cancel32} style={{ width: '1.2rem', paddingBottom: '3px', fontSize: '15px' }} /> Cancel</button>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {showRejectModal && rejectingExpense && (
                <>
                  <div className="modal-backdrop" onClick={() => setShowRejectModal(false)} />

                  <div className="modal-content-box">
                    <h5 style={{ textAlign: 'center' }}>Reject Confirmation</h5>
                    <p style={{ textAlign: 'center' }}>
                      Are you sure you want to reject the request by <b>{rejectingExpense.User_Name}</b> for project <b>{rejectingExpense.Project_Name}</b>?
                    </p>

                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
                      <button
                        className="btn btn-danger mx-2"
                        onClick={handleRejectSubmit}
                      >
                        Yes, Reject
                      </button>
                      <button
                        className="btn btn-secondary mx-2"
                        onClick={() => setShowRejectModal(false)}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 3rem', height: '3rem', alignItems: 'center' }}>
                <div>
                <p>Showing {indexOfFirstBill + 1} to {Math.min(indexOfLastBill, expenses.length)} of {expenses.length} entries</p>

                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {/* First Page Button */}
                    <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0 }}>
                        &laquo;
                    </button>
                    {/* Previous Button */}
                    <button
                        onClick={() => setCurrentPage(currentPage - 1)}
                        disabled={currentPage === 1}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                        &lt;
                    </button>

                    <button
                        style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '24px', width: '3rem', margin: 0, borderRadius: 0, border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
                    </button>
                    {/* Next Button */}
                    <button
                        onClick={() => setCurrentPage(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                        &gt;
                    </button>
                    {/* Last Page Button */}
                    <button
                        onClick={() => setCurrentPage(totalPages)}
                        disabled={currentPage === totalPages}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                        &raquo;
                    </button>
                </div>

            </div>
        </div>
      </div>
    </>
  )
}

export default Requisitions